import db from '@mobile/db/db';
import ChecklistService from '@mobile/services/checklist';
import { eventBus } from '@/eventBus';
import { now } from '@/util/UnixTimestamps';

const storeName = 'checklists';

export default {

    async get(key) {
        await db.open();
        return db.get(storeName, parseInt(key, 10));
    },

    async put(checklist) {
        await db.open();
        return db.put(storeName, checklist);
    },

    async getAll() {
        await db.open();
        return db.getAll(storeName);
    },

    async update(id) {
        const checklist = await this.get(id);
        if (checklist) {
            checklist.checked_at = now();
            await db.put(storeName, checklist);
        }
    },

    async updateAll() {
        const checklists = await ChecklistService.getAll();
        if (!checklists) return;

        await db.open();
        const currentChecklistKeys = await db.getAllKeys(storeName);

        await Promise.all(
            currentChecklistKeys.map(
                (id) => (!checklists.find((checklist) => checklist.id === id)) && db.delete(storeName, id),
            ),
        );

        const updateLocalChecklist = (checklist) => db.put(storeName, {
            ...checklist,
            checked_at: now(),
        });

        const total = Object.keys(checklists).length;

        for (const i in checklists) {
            const checklist = checklists[i];
            const localChecklist = await this.get(checklist.id);

            const shouldFetchUpdatedChecklist = !localChecklist || checklist.updated_at > localChecklist.updated_at;
            if (shouldFetchUpdatedChecklist) {
                const updatedChecklist = await ChecklistService.get(checklist.id);
                await updateLocalChecklist(updatedChecklist);
            } else if (localChecklist) {
                await updateLocalChecklist(localChecklist);
            }
            eventBus.$emit('downloadProgress', { total, loaded: (parseInt(i, 10) + 1) });
        }
    },

};
